import { useMemo } from 'react';
import useGraphqlQuery from '@elementary/common-ui/hooks/useGraphqlQuery';
import { getTreeViewQuery } from '@elementary/common-ui/services/api';
import {
  TABLE_ASSETS,
  TREE_CATEGORIES,
} from '@elementary/common-ui/constants/queryKeys';
import { TreeNode } from '@elementary/common-ui/types';
import { Query } from '@elementary/common-ui/services/gql/types';
import buildPathsFromTreeData from 'shared/utils/buildPathsFromTreeData';
import { getRuleDrawerAssetsQuery } from '../../services/api';
import { RuleAsset, RuleDrawerAssetsResponse } from '../../types';

const useRuleDrawerFilterData = (envId: string) => {
  const { data: assets } = useGraphqlQuery<RuleAsset[]>({
    query: getRuleDrawerAssetsQuery,
    queryKey: [TABLE_ASSETS, envId, 'rule-drawer'],
    select: (response: RuleDrawerAssetsResponse) => response.tableAssets.items,
    enabled: !!envId,
    envId,
  });

  const { data: biAssetsTree } = useGraphqlQuery<TreeNode | null>({
    query: getTreeViewQuery,
    queryKey: [TREE_CATEGORIES, envId, 'BI_ASSETS', 'PATHS', 'rule-drawer'],
    variables: {
      category: 'BI_ASSETS',
      view: 'PATHS',
      filters: [],
      includeTotals: false,
    },
    select: (response: Pick<Query, 'treeView'>) =>
      response.treeView?.data ?? null,
    enabled: !!envId,
    envId,
  });

  const { data: dataAssetsTree } = useGraphqlQuery<TreeNode | null>({
    query: getTreeViewQuery,
    queryKey: [TREE_CATEGORIES, envId, 'DATA_ASSETS', 'PATHS', 'rule-drawer'],
    variables: {
      category: 'DATA_ASSETS',
      view: 'PATHS',
      filters: [],
      includeTotals: false,
    },
    select: (response: Pick<Query, 'treeView'>) =>
      response.treeView?.data ?? null,
    enabled: !!envId,
    envId,
  });

  const paths = useMemo(
    () => [
      ...buildPathsFromTreeData(biAssetsTree),
      ...buildPathsFromTreeData(dataAssetsTree),
    ],
    [biAssetsTree, dataAssetsTree],
  );

  return { assets: assets ?? [], paths };
};

export default useRuleDrawerFilterData;
